module.exports = __webpack_public_path__ + "e3c34450e8edfd63b1e5a410a38e647f.svg";